import React, { useMemo } from "react";
import TinyEditor from "src/components/ckeditor/Ckeditor";
import { uploadImageOns3 } from "src/DAL/commonApi/commonApi";
import { s3baseUrl } from "src/config/config";

/**
 * TinyMCE 6+ expects a Promise-based upload handler. Images inside emails
 * must be absolute URLs, so the S3 base is prepended.
 */
const uploadEmailImage = (blobInfo) => {
  const formData = new FormData();
  formData.append("image", blobInfo.blob());
  formData.append("width", "600");
  return uploadImageOns3(formData).then((res) => {
    if (res?.code === 200 && res.image_path) return s3baseUrl + res.image_path;
    return Promise.reject({
      message: res?.message || "Image upload failed",
      remove: true,
    });
  });
};

const EMAIL_EDITOR_INIT = {
  // Emails are read outside the admin app — keep every URL absolute.
  relative_urls: false,
  remove_script_host: false,
  convert_urls: true,
  menubar: false,
  toolbar:
    "undo redo | blocks | bold italic underline forecolor backcolor | " +
    "alignleft aligncenter alignright | bullist numlist | link image | " +
    "removeformat",
};

/**
 * Rich-text body for automation emails (HTML).
 * `onEditorReady(editor)` exposes the editor so callers can
 * `editor.insertContent("{{token}}")` at the caret.
 * EDITOR-KIT: TinyEditor now shows React Editor Kit (short email toolbar,
 * kitVariant="email"); `init` is only used by the old TinyMCE editor.
 */
export default function EmailContentEditor({
  value,
  onChange,
  onEditorReady,
  onFocus,
  height = 360,
}) {
  const init = useMemo(
    () => ({ ...EMAIL_EDITOR_INIT, images_upload_handler: uploadEmailImage }),
    []
  );

  const handleInit = (editor) => {
    if (onFocus) editor.on("focus", onFocus);
    if (onEditorReady) onEditorReady(editor);
  };

  return (
    <TinyEditor
      detailDescriptionCk={value || ""}
      setDetailDescription={onChange}
      height={height}
      init={init}
      onInit={handleInit}
      kitVariant="email"
    />
  );
}
